var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookMessengerDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "facebookmessengerdefault-a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006AFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(0 .016)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebookmessengerdefault-a)",
    d: "M16,0 C6.98591549,0 0,6.6028169 0,15.5203219 C0,20.1851107 1.91227364,24.2156942 5.02535211,27.0004024 C5.2861167,27.2354125 5.44386318,27.5605634 5.45674044,27.9114688 L5.54366197,30.7573441 C5.57263581,31.6651911 6.50945674,32.254326 7.34004024,31.8905433 L10.5142857,30.4901408 C10.7847082,30.3710262 11.0841046,30.3484909 11.3674044,30.4257545 C12.8257545,30.828169 14.3806841,31.0406439 16,31.0406439 C25.0140845,31.0406439 32,24.437827 32,15.5203219 C32,6.6028169 25.0140845,0 16,0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.12087063,19.9909289 L11.6786415,12.7609308 C12.40289,11.6121228 13.9575269,11.3249208 15.0438997,12.1397003 L18.6682641,14.8587541 C19.0022925,15.1084949 19.4580696,15.1053732 19.7889762,14.8556323 L24.6838973,11.1407369 C25.3363453,10.6443769 26.1917078,11.4279389 25.7515395,12.1209698 L21.1968904,19.3478462 C20.4726419,20.4966542 18.9180049,20.7838562 17.8316322,19.9690766 L14.2072678,17.2500229 C13.8732394,17.000282 13.4174623,17.0034038 13.0865556,17.2531447 L8.18851285,20.9711618 C7.53606482,21.4675218 6.68070235,20.6839598 7.12087063,19.9909289 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessengerDefault);
export default __webpack_public_path__ + "static/media/FacebookMessengerDefault.00ec06f4.svg";
export { ForwardRef as ReactComponent };